<template>
  <div class="dialog-body">
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      append-to-body
      width="40%"
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block"
              ><i class="el-icon-circle-close"></i>删除后将不可恢复，您确定要删除吗?</span
            >
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure">确定</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import serviceContractApi from '@/api/purchaseSalesCenter/outerServiceContract.js';
  export default {
    name: 'deleteContractDialog',
    props: ['deleteIds'],
    data() {
      return {
        dialogVisible: false,
        ids: [],
      };
    },
    methods: {
      openDialog() {
        this.dialogVisible = true;
      },
      handleClose() {
        this.dialogVisible = false;
      },
      async handleSure() {
        console.log(this.ids, '传过来的ids');
        const { data } = await this.$axios.post(
          `${serviceContractApi.DELETE_CONTRACT}?oaId=${this.userInfo.oaId}`,
          this.ids
        );
        if (data.code == 0) {
          this.$message.success('删除成功！');
        } else {
          this.$message.error('删除失败！');
        }
        this.dialogVisible = false;
        this.$emit('operateSuccess');
      },
    },
    watch: {
      deleteIds: {
        handler(val) {
          if (val == []) {
            this.ids = [];
          }
          this.ids = val;
        },
        immediate: false,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-icon-circle-close {
    color: red;
  }
</style>
